/* ── Base ── */
.badge {
  display: inline-flex;
  align-items: center;
  border-radius: var(--radius-full);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
  line-height: var(--line-height-tight);
}

/* ── Sizes ── */
.sm {
  padding: 0.125rem 0.5rem;
  font-size: var(--font-size-xs);
}

.md {
  padding: 0.25rem 0.625rem;
  font-size: var(--font-size-sm);
}

/* ── Variants ── */
.success {
  background-color: var(--color-success);
  color: var(--color-text);
}

.warning {
  background-color: var(--color-warning-light);
  color: var(--color-text);
}

.error {
  background-color: var(--color-error-light);
  color: var(--color-error);
}

.info {
  background-color: var(--color-primary);
  color: var(--color-text-inverse);
}

.neutral {
  background-color: var(--color-bg-secondary);
  color: var(--color-text-secondary);
}
